import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-[#010b27] bg-[#010b27] text-white pt-12 pb-8">
      <div className="mx-auto max-w-7xl px-4">
        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 pb-10 border-b border-slate-800/80">
          {/* Column 1: Brand & Editorial Profile */}
          <div className="lg:col-span-1">
            <Logo variant="footer" />
            <p className="mt-4 text-xs text-slate-400 leading-relaxed">
              Skatunderlup er et uafhængigt, redaktionelt nyhedsmedie dedikeret til at belyse skatter, moms, afgifter og retssikkerhed for private borgere og danske virksomheder.
            </p>
            <div className="mt-5 text-[11px] text-slate-400">
              <span className="text-[#fd7302] font-semibold uppercase tracking-wider block mb-1">
                Redaktionel uafhængighed
              </span>
              Artikler og analyser udarbejdes efter journalistiske principper og udgør ikke personlig skatterådgivning.
            </div>
          </div>

          {/* Column 2: Redaktionelle sektioner */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-[#fd7302] pb-2 border-b border-slate-800">
              Sektioner
            </h4>
            <ul className="mt-3 space-y-2 text-sm text-slate-300">
              <li>
                <Link to="/" className="hover:text-[#fd7302] transition-colors">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/private" className="hover:text-[#fd7302] transition-colors flex items-center justify-between">
                  <span>For Private</span>
                  <span className="text-[10px] bg-slate-800 text-slate-300 px-2 py-0.5 rounded-sm">Borger</span>
                </Link>
              </li>
              <li>
                <Link to="/erhvervsdrivende" className="hover:text-[#fd7302] transition-colors flex items-center justify-between">
                  <span>For Erhvervsdrivende</span>
                  <span className="text-[10px] bg-[#fd7302]/20 text-[#fd7302] px-2 py-0.5 rounded-sm font-semibold">Erhverv</span>
                </Link>
              </li>
              <li>
                <Link to="/artikler" className="hover:text-[#fd7302] transition-colors">
                  Artikler & Analyser
                </Link>
              </li>
              <li>
                <Link to="/presse-og-film" className="hover:text-[#fd7302] transition-colors">
                  Presse & Film
                </Link>
              </li>
              <li>
                <Link to="/om-skat" className="hover:text-[#fd7302] transition-colors">
                  Om skat (Vidensunivers)
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Rådgivning & Hjælp */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-[#fd7302] pb-2 border-b border-slate-800">
              Hjælp & Vejledning
            </h4>
            <p className="mt-3 text-xs text-slate-400 leading-relaxed">
              Står du med en konkret skattesag, kontrolbesøg eller klage over Skattestyrelsen?
            </p>
            <div className="mt-4 space-y-2.5">
              <Link
                to="/kontakt"
                className="inline-flex w-full items-center justify-between rounded-sm border border-slate-700 bg-slate-900/80 px-3 py-2 text-xs font-semibold text-slate-200 hover:border-[#fd7302] hover:text-white transition-colors"
              >
                <span>Udfyld kontaktformular</span>
                <i className="fa-solid fa-arrow-right text-[10px] text-[#fd7302]" aria-hidden="true" />
              </Link>
              <Link
                to="/kontakt"
                className="inline-flex w-full items-center justify-between rounded-sm bg-[#fd7302] px-3 py-2 text-xs font-semibold text-white hover:bg-[#e06500] transition-colors"
              >
                <span>Martin Krogh Skatterådgivning</span>
                <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
              </Link>
            </div>
          </div>

          {/* Column 4: Kontaktoplysninger (Never break email/phone over lines) */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-[#fd7302] pb-2 border-b border-slate-800">
              Kontakt Redaktionen
            </h4>
            <div className="mt-3 space-y-3 text-xs text-slate-300">
              <div>
                <span className="text-[11px] text-slate-400 block">Udgiver:</span>
                <span className="font-semibold text-white text-sm">Skatunderlup</span>
              </div>

              <div>
                <span className="text-[11px] text-slate-400 block">Redaktionschef:</span>
                <span className="font-semibold text-white text-sm block">Pernille Thejlade</span>
                <a
                  href="tel:50364043"
                  className="inline-block whitespace-nowrap font-medium text-white hover:text-[#fd7302] transition-colors mt-0.5"
                  title="Ring til Pernille Thejlade på 50 36 40 43"
                >
                  <i className="fa-solid fa-phone mr-1.5 text-[10px] text-[#fd7302]" aria-hidden="true" />
                  <span className="whitespace-nowrap">50 36 40 43</span>
                </a>
                <a
                  href="mailto:pnt@lexnovo.dk"
                  className="block whitespace-nowrap font-medium text-white hover:text-[#fd7302] transition-colors mt-0.5"
                  title="Send e-mail til Pernille Thejlade på pnt@lexnovo.dk"
                >
                  <i className="fa-solid fa-envelope mr-1.5 text-[10px] text-[#fd7302]" aria-hidden="true" />
                  <span className="whitespace-nowrap">pnt@lexnovo.dk</span>
                </a>
              </div>

              <div>
                <span className="text-[11px] text-slate-400 block">Adresse:</span>
                <address className="not-italic text-slate-300">
                  128 City Road, 0000 London
                </address>
              </div>

              <div>
                <span className="text-[11px] text-slate-400 block">Telefon:</span>
                <a
                  href="tel:61444604"
                  className="inline-block whitespace-nowrap font-medium text-white hover:text-[#fd7302] transition-colors"
                  title="Ring til 61 44 46 04"
                >
                  <i className="fa-solid fa-phone mr-1.5 text-[10px] text-[#fd7302]" aria-hidden="true" />
                  <span className="whitespace-nowrap">61 44 46 04</span>
                </a>
              </div>

              <div>
                <span className="text-[11px] text-slate-400 block">E-mail:</span>
                <a
                  href="mailto:mmkh@lexnovo.dk"
                  className="inline-block whitespace-nowrap font-medium text-white hover:text-[#fd7302] transition-colors"
                  title="Skriv til mmkh@lexnovo.dk"
                >
                  <i className="fa-solid fa-envelope mr-1.5 text-[10px] text-[#fd7302]" aria-hidden="true" />
                  <span className="whitespace-nowrap">mmkh@lexnovo.dk</span>
                </a>
              </div>

              <div className="pt-2">
                <Link
                  to="/kontakt"
                  className="inline-flex items-center gap-1.5 text-xs text-slate-300 hover:text-[#fd7302] underline underline-offset-4"
                >
                  <span>Gå til kontaktformular</span>
                  <i className="fa-solid fa-chevron-right text-[9px]" aria-hidden="true" />
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-400">
          <p>© {new Date().getFullYear()} Skatunderlup. Alle rettigheder forbeholdes.</p>
          <p className="italic text-slate-400">
            Digital journalistik for skat og afgifter
          </p>
        </div>
      </div>
    </footer>
  );
}
